var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyJourney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.331,
    height: 8.908,
    viewBox: "0 0 16.331 8.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#180058;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.831,10.485a1.489,1.489,0,0,1-1.485,1.485,1.262,1.262,0,0,1-.379-.052l-2.643,2.635a1.311,1.311,0,0,1,.052.386,1.485,1.485,0,0,1-2.969,0,1.311,1.311,0,0,1,.052-.386L8.567,12.66a1.46,1.46,0,0,1-.772,0L4.417,16.044a1.262,1.262,0,0,1,.052.379,1.485,1.485,0,1,1-1.485-1.485,1.262,1.262,0,0,1,.379.052l3.385-3.377a1.311,1.311,0,0,1-.052-.386,1.485,1.485,0,0,1,2.969,0,1.311,1.311,0,0,1-.052.386l1.893,1.893a1.46,1.46,0,0,1,.772,0l2.635-2.643a1.262,1.262,0,0,1-.052-.379,1.485,1.485,0,1,1,2.969,0Z",
    transform: "translate(-1.5 -9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyJourney);
export default __webpack_public_path__ + "static/media/my-journey.746e5e4d8df846d8d6aeee8a35138304.svg";
export { ForwardRef as ReactComponent };